import { MY_HR_CREATE_CHANGE_REQUEST } from "my-hr/graphql";
import * as Yup from "yup";

export const mothersNameDialogDef = {
  type: "mothersName",
  dialogLabel: "MY_HR_EDIT_MOTHERS_NAME",
  mutation: MY_HR_CREATE_CHANGE_REQUEST,
  items: [
    {
      label: "OC_VALIDITY",
      name: "validFrom",
      type: "datePicker",
      validation: Yup.date().required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "MY_HR_PREFIXNAME",
      name: "mothersNamePrefix",
      dataField: "mothersNamePrefix",
      type: "text",
      validation: Yup.string(),
    },
    {
      label: "MY_HR_LASTNAME",
      name: "mothersLastName",
      dataField: "mothersLastName",
      type: "text",
      validation: Yup.string()
        .trim()
        .required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "MY_HR_FIRSTNAME",
      name: "mothersFirstName",
      dataField: "mothersFirstName",
      type: "text",
      validation: Yup.string()
        .trim()
        .required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "MY_HR_MIDDLENAME",
      name: "mothersFirstName2",
      dataField: "mothersFirstName2",
      type: "text",
      validation: Yup.string(),
    },
    {
      label: "MY_HR_NAMESUFFIX",
      name: "mothersNameSuffix",
      dataField: "mothersNameSuffix",
      type: "text",
      validation: Yup.string(),
    },
    {
      label: "OC_MESSAGE",
      name: "initialMessage",
      type: "textarea",
      validation: Yup.string(),
    },
  ],
};
